import { ArrowUpRight, ChevronDown, Sparkles } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { CONTACT, FAQS } from "@/lib/data";
import { Reveal } from "@/components/Reveal";

export default function FaqSection() {
  return (
    <section className="py-24 lg:py-28 bg-medis-subtle/60 border-y border-medis-silver/20" data-testid="dotmedixa-faq-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-5 space-y-6">
            <Reveal>
              <div>
                <div className="text-[11.5px] uppercase tracking-[0.22em] text-medis-teal font-semibold">Explore More Solutions</div>
                <h2 className="mt-3 font-display font-bold text-medis-navy text-3xl sm:text-[36px] leading-[1.1] tracking-tight" id="faq">
                  Discover additional specialized offerings.
                </h2>
              </div>
              <a
                href={CONTACT.dotmedixa}
                target="_blank"
                rel="noopener noreferrer"
                className="hover-lift group block rounded-xl border border-medis-blue/20 bg-medis-blue text-white p-7 relative overflow-hidden mt-6"
                data-testid="dotmedixa-cta"
              >
                <div className="absolute -top-16 -right-16 h-56 w-56 rounded-full bg-medis-teal/25 blur-3xl" />
                <div className="relative">
                  <div className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-3 py-1 text-[10.5px] uppercase tracking-[0.18em] font-semibold">
                    <Sparkles className="h-3 w-3" /> Partner Brand
                  </div>
                  <div className="mt-5 font-display font-bold text-3xl tracking-tight">Dotmedixa</div>
                  <p className="mt-2 text-[14px] text-white/80 leading-relaxed max-w-sm">
                    Discover additional specialized medical offerings from our extended ecosystem.
                  </p>
                  <div className="mt-6 inline-flex items-center gap-2 rounded-md bg-white text-medis-blue px-4 py-2.5 text-[13px] font-semibold group-hover:bg-medis-teal group-hover:text-white transition-colors">
                    View More <ArrowUpRight className="h-4 w-4" />
                  </div>
                </div>
              </a>
              <div className="grid grid-cols-2 gap-3">
                <div className="rounded-md border border-medis-silver/30 bg-white p-5">
                  <div className="font-display font-bold text-medis-blue text-3xl">17+</div>
                  <div className="mt-1 text-[12.5px] text-medis-gray leading-snug">Years of industry expertise</div>
                </div>
                <div className="rounded-md border border-medis-silver/30 bg-white p-5">
                  <div className="font-display font-bold text-medis-blue text-3xl">Pan-India</div>
                  <div className="mt-1 text-[12.5px] text-medis-gray leading-snug">Services & support coverage</div>
                </div>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <Reveal>
              <div className="text-[11.5px] uppercase tracking-[0.22em] text-medis-teal font-semibold">Frequently Asked Questions</div>
              <h3 className="mt-3 font-display font-bold text-medis-navy text-2xl sm:text-3xl lg:text-[36px] leading-[1.15] tracking-tight">
                Common questions from hospitals & diagnostic centres.
              </h3>
              <Accordion type="single" collapsible className="mt-8 divide-y divide-medis-silver/30 rounded-lg border border-medis-silver/30 bg-white" data-testid="faq-accordion">
                {FAQS.map((f, i) => (
                  <AccordionItem key={i} value={`faq-${i}`} className="border-0 px-5 sm:px-7" data-testid={`faq-item-${i}`}>
                    <AccordionTrigger className="flex flex-1 items-center justify-between text-left font-display font-semibold text-medis-navy text-[15.5px] py-5 hover:no-underline">
                      {f.q}
                    </AccordionTrigger>
                    <AccordionContent className="text-medis-gray text-[14px] leading-relaxed pb-5">{f.a}</AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
